import { render, staticRenderFns } from "./HandoverForm.vue?vue&type=template&id=5b026371"
import script from "./HandoverForm.vue?vue&type=script&lang=js"
export * from "./HandoverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports